<template>
    <div>
        <helpInfo :helpData="helpData"></helpInfo>
        <div style="padding: 15px;">
            <Button @click="getList"
                    style="margin-right: 8px">
                <i class="icon-refresh-o-2"></i>
            </Button>
            <Button type="primary"
                    :disabled="!hasPermission('CF0901') || !selected.length"
                    @click="setAddressee()">
                配置接收人
            </Button>
            <div class="msg-config-panel">
                <table class="custom-table ivu-table-default ivu-table-border"
                       cellspacing="0"
                       cellpadding="0">
                    <thead>
                        <tr>
                            <th width="30%">
                                <Checkbox v-model="selectedAll"
                                          @on-change="selectedAllChange($event)"></Checkbox>
                                {{ $t('消息类型') }}
                            </th>
                            <th width="10%">
                                {{ $t('站内信') }}
                                <Tooltip translate
                                         placement="right"
                                         :content="$t('具备站内信功能的角色可查看。')">
                                    <i class="icon-prompt-1-o"
                                       style="margin-left: 5px;"></i>
                                </Tooltip>
                            </th>
                            <th width="10%">{{ $t('邮件') }}</th>
                            <th width="10%">{{ $t('短信') }}</th>
                            <th width="30%">{{ $t('消息接收人') }}</th>
                            <th width="10%">{{ $t('操作') }}</th>
                        </tr>
                    </thead>
                    <tr v-show="loading">
                        <td colspan="6">
                            <loading style="min-height: 80px"></loading>
                        </td>
                    </tr>
                    <tbody v-show="!loading"
                           class="ivu-table-tbody">
                        <template v-for="item in msgData">
                            <tr :key="item.id"
                                class="ivu-table-row">
                                <td>
                                    <div class="flex-td">
                                        <Icon class="fold-icon"
                                              :type="item._fold?'ios-remove':'ios-add'"
                                              @click="item._fold = !item._fold" />
                                        <Checkbox v-model="item.selected"
                                                  @on-change="selectedAllChange($event, [item])"
                                                  style="margin-left: 8px;"></Checkbox>
                                        {{ item.msgTypeName }}
                                    </div>
                                </td>
                                <td>
                                    <Tooltip translate
                                             placement="right"
                                             :disabled="item.msgIsEditable === 1"
                                             :content="$t('该消息暂不支持当前渠道发送消息配置。')">
                                        <Checkbox :disabled="item.msgIsEditable === 0 || !hasPermission('CF0903')"
                                                  v-model="item.msgStatus"
                                                  :true-value="1"
                                                  :false-value="0"
                                                  @on-change="statusChange($event, item, 'msg')"></Checkbox>
                                    </Tooltip>
                                </td>
                                <td>
                                    <Tooltip translate
                                             placement="right"
                                             :disabled="item.emailIsEditable === 1"
                                             :content="$t('该消息暂不支持当前渠道发送消息配置。')">
                                        <Checkbox :disabled="item.emailIsEditable === 0 || !hasPermission('CF0903')"
                                                  v-model="item.emailStatus"
                                                  :true-value="1"
                                                  :false-value="0"
                                                  @on-change="statusChange($event, item, 'email')"></Checkbox>
                                    </Tooltip>
                                </td>
                                <td>
                                    <Tooltip translate
                                             placement="right"
                                             :disabled="item.smsIsEditable === 1"
                                             :content="$t('该消息暂不支持当前渠道发送消息配置。')">
                                        <Checkbox :disabled="item.smsIsEditable === 0 || !hasPermission('CF0903')"
                                                  v-model="item.smsStatus"
                                                  :true-value="1"
                                                  :false-value="0"
                                                  @on-change="statusChange($event, item, 'sms')"></Checkbox>
                                    </Tooltip>
                                </td>
                                <td>
                                    <div :title="item.contactNames">{{item.contactNames || '--'}}</div>
                                </td>
                                <td>
                                    <a :class="!hasPermission('CF0901') && 'disabled'"
                                       @click="hasPermission('CF0901') && setAddressee(item.tree)">{{ $t('配置接收人') }}</a>
                                </td>
                            </tr>
                            <template v-if="item._fold">
                                <tr v-for="child in item.tree"
                                    :key="child.id"
                                    :class="!child.tree && 'child-tr'"
                                    class="ivu-table-row">
                                    <td>
                                        <div class="flex-td">
                                            <Checkbox v-model="child.selected"
                                                      @on-change="selectedChange($event, child)"></Checkbox>
                                            {{ child.msgName }}
                                            <Tooltip v-if="child.msgDescription"
                                                     translate
                                                     placement="right">
                                                <div slot="content"
                                                     style="white-space: normal;">{{child.msgDescription}}</div>
                                                <i class="icon-prompt-1-o"
                                                   style="margin-left: 5px;"></i>
                                            </Tooltip>
                                        </div>
                                    </td>
                                    <td>
                                        <Tooltip translate
                                                 placement="right"
                                                 :disabled="child.msgIsEditable === 1"
                                                 :content="$t('该消息暂不支持当前渠道发送消息配置。')">
                                            <Checkbox :disabled="child.msgIsEditable === 0"
                                                      v-model="child.msgStatus"
                                                      :true-value="1"
                                                      :false-value="0"
                                                      @on-change="statusChange($event, child, 'msg')"></Checkbox>
                                        </Tooltip>
                                    </td>
                                    <td>
                                        <Tooltip translate
                                                 placement="right"
                                                 :disabled="child.emailIsEditable === 1"
                                                 :content="$t('该消息暂不支持当前渠道发送消息配置。')">
                                            <Checkbox :disabled="child.emailIsEditable === 0"
                                                      v-model="child.emailStatus"
                                                      :true-value="1"
                                                      :false-value="0"
                                                      @on-change="statusChange($event, child, 'email')"></Checkbox>
                                        </Tooltip>
                                    </td>
                                    <td>
                                        <Tooltip translate
                                                 placement="right"
                                                 :disabled="child.smsIsEditable === 1"
                                                 :content="$t('该消息暂不支持当前渠道发送消息配置。')">
                                            <Checkbox :disabled="child.smsIsEditable === 0"
                                                      v-model="child.smsStatus"
                                                      :true-value="1"
                                                      :false-value="0"
                                                      @on-change="statusChange($event, child, 'sms')"></Checkbox>
                                        </Tooltip>
                                    </td>
                                    <td>
                                        <div :title="child.contactNames">{{child.contactNames || '--'}}</div>
                                    </td>
                                    <td>
                                        <a :class="!hasPermission('CF0901') && 'disabled'"
                                           @click="hasPermission('CF0901') && setAddressee([child])">{{ $t('配置接收人') }}</a>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
            <SetAddressee ref="setAddressee"
                          @refresh="getList" />
        </div>
    </div>
</template>
<script>

import helpInfo from '@c/basic/helpinfo'
import API from '@/service/api.js'
import loading from '@c/basic/loading'
import SetAddressee from './components/setaddressee.vue'
export default {
    name: 'MsgConfig',
    components: {
        helpInfo,
        loading,
        SetAddressee
    },
    data () {
        return {
            helpData: {
                modelName: '消息设置'
            },
            loading: false,
            selectedAll: false,
            msgData: [],
            selected: []

        }
    },
    created () {
        this.getList()
    },
    methods: {
        getList () {
            this.loading = true
            this.selected = []
            this.axios.get(this.urlFormat(API.MSG, true)).then(res => {
                this.formatData(res)
                this.loading = false
            })
        },
        formatData (msgData) {
            msgData.forEach(item => {
                item._fold = true
                item.tree.forEach(child => {
                    child._selected = true
                })
            })
            this.msgData = msgData
        },
        setAddressee (data) {
            this.$refs.setAddressee.open(data || this.selected)
        },
        // 全选、全不选
        selectedAllChange (status, data) {
            const msgData = data || this.msgData
            msgData.map(item => {
                item.selected = status
                item.tree.map(child => {
                    child.selected = status
                })
            })
            this.selected = status ? msgData.map(item => item.tree).flat() : []
        },
        // 单个勾选
        selectedChange (status, data) {
            if (status) {
                this.selected.push(data)
            } else {
                this.selected = this.selected.filter(item => item.id !== data.id)
            }
        },
        statusChange (status, item, type) {
            const typeTxt = {
                sms: '短信',
                email: '邮件',
                msg: '站内信'
            }[type]
            let msg = ''
            let desc = ''
            let ids = []
            if (item.tree) { // 父节点
                msg = `确认批量${status ? '开启' : '关闭'}消息发送设置?`
                desc = `确定批量${status ? '开启' : '关闭'}[${item.msgTypeName}]的[${typeTxt}]吗？建议您接收该类型消息，防止遗漏消息造成损失。`
                ids = item.tree.map(({ id }) => id)
            } else {
                msg = `确认${status ? '开启' : '关闭'}消息发送设置?`
                desc = `确定${status ? '开启' : '关闭'}[${item.msgTypeName}]的[${typeTxt}]吗？建议您接收该类型消息，防止遗漏消息造成损失。`
                ids = [item.id]
            }
            const statusKey = {
                sms: 'smsStatus',
                email: 'emailStatus',
                msg: 'msgStatus'
            }[type]
            const typeParam = { // 主要email的时候传参不统一
                sms: 'sms',
                email: 'mail',
                msg: 'msg'
            }[type]
            this.$Modal.confirm({
                title: this.$t(msg),
                okText: this.$t('确定'),
                cancelText: this.$t('取消'),
                width: 460,
                content: `<div class="rc-modal-confirm">${desc}</div>`,
                onOk: () => {
                    this.axios.put(this.urlFormat(API.MSG, true), { ids, status, type: typeParam }).then(res => {
                        if (res.status) {
                            this.getList()
                        } else {
                            item[statusKey] = Number(!status)
                        }
                    }).catch(() => {
                        item[statusKey] = Number(!status)
                    })
                },
                onCancel: () => {
                    item[statusKey] = Number(!status)
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.msg-config-panel {
    margin-top: 15px;
    a.disabled {
        color: #c5c8ce;
        cursor: not-allowed;
    }
    .custom-table {
        width: 100%;
        font-size: 12px;
        color: #333;
        table-layout: fixed;
        th {
            text-align: left;
        }
        tr {
            margin: 0;
            padding: 0;
            height: 42px;
            font-size: 12px;
            border-collapse: collapse;

            .no-data {
                text-align: center;
                font-size: 14px;
                color: #909399;
            }
        }
        .child-tr {
            & > td:first-child {
                padding-left: 35px;
            }
        }

        tr:hover > td {
            background-color: #f5f7fa;
        }

        tr:last-child {
            td.item-td {
                border-bottom: 0;
            }
        }
        th {
            height: 42px;
            font-size: 14px;
            font-weight: 500;
            padding: 8px;
            background-color: #f0f2f3;
            border: none;
            border-right: 1px solid #e9e9e9;
        }

        td {
            padding: 0 8px;
            height: 42px;
            border: none;
            & > div {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        td:last-child {
            border-right: 0;
        }

        th:last-child {
            padding-right: 10px;
        }
    }
    .fold-icon {
        border: 1px solid #e9e9e9;
    }
    .flex-td {
        display: flex;
        align-items: center;
    }
}
</style>
